import useDropdow from "../../customHooks/useDropdow";
type Placement =
  | "auto"
  | "auto-start"
  | "auto-end"
  | "top"
  | "top-start"
  | "top-end"
  | "bottom"
  | "bottom-start"
  | "bottom-end"
  | "right"
  | "right-start"
  | "right-end"
  | "left"
  | "left-start"
  | "left-end";

interface Props {
  overlay: React.ReactNode;
  children: React.ReactNode;
  placement: Placement;
  margin: number;
}
const Dropdown = ({ overlay, children, placement, margin }: Props) => {
  const {
    setReferenceElement,
    setPopperElement,
    styles,
    attributes,
    refPopper,
    isOpen,
    setisOpen,
  } = useDropdow({ placement, margin });
  return (
    <div className="c-dropdown" ref={refPopper}>
      <div
        className="c-dropdown__children"
        ref={setReferenceElement}
        onClick={() => setisOpen((o) => !o)}
      >
        {children}
      </div>
      <div
        className={`c-dropdown__overley ${
          isOpen && `c-dropdown__overley--active`
        }`}
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
      >
        <div
          className={`c-dropdown__content ${
            isOpen && `c-dropdown__content--active`
          }`}
          onClick={() => setisOpen((o) => !o)}
        >
          {overlay}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
